import { useQuery } from 'hooks/useCustomQuery';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/services/axios';
import { toast } from 'react-toastify';

export const useGetOCProfiles = () => {
    return useQuery({
        queryKey: ['ocProfiles'],
        queryFn: async () => {
            const response = await axios.get(
                '/operatorconnectoperatorprofiles',
            );
            return response.data;
        },
    });
};

export const useGetOCProfile = (id) => {
    return useQuery({
        queryKey: ['ocProfile', id],
        queryFn: async () => {
            const response = await axios.get(
                `/operatorconnectoperatorprofile/${id}`,
            );
            return response.data;
        },
        enabled: !!id,
    });
};

export const useAddOCProfile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            const response = await axios.post(
                '/operatorconnectoperatorprofile',
                data,
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['ocProfiles']);
            toast.success('Operator Profile added successfully');
        },
        onError: (error) => {
            toast.error(`Failed to add Operator Profile: ${error.message}`);
        },
    });
};

export const useUpdateOCProfile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            const response = await axios.put(
                '/operatorconnectoperatorprofile',
                data,
            );
            return response.data;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries(['ocProfiles']);
            queryClient.invalidateQueries(['ocProfile', data.id]);
            toast.success('Operator Profile updated successfully');
        },
        onError: (error) => {
            toast.error(`Failed to update Operator Profile: ${error.message}`);
        },
    });
};

export const useGetConsents = (profileId) => {
    return useQuery({
        queryKey: ['ocConsents', profileId],
        queryFn: async () => {
            const response = await axios.get(
                `/OperatorConnectOperatorConsents/${profileId}`,
            );
            return response.data;
        },
        enabled: !!profileId,
    });
};

export const useGetConsent = (consentId) => {
    return useQuery({
        queryKey: ['ocConsent', consentId],
        queryFn: async () => {
            const response = await axios.get(
                `/OperatorConnectOperatorConsent/${consentId}`,
            );
            return response.data;
        },
        enabled: !!consentId,
    });
};

export const useGetConsentHistory = (consentId, isActive = false) => {
    return useQuery({
        queryKey: ['ocConsentHistory', consentId],
        queryFn: async () => {
            const response = await axios.get(
                `/OperatorConnectOperatorConsent/${consentId}/History`,
            );
            return response.data;
        },
        enabled: !!consentId && isActive,
    });
};

export const useGetRegions = (wholesalerId) => {
    return useQuery({
        queryKey: ['regions', wholesalerId],
        queryFn: async () => {
            const response = await axios.get(
                `/wholesaler/${wholesalerId}/regions/all`,
            );
            return response.data;
        },
        enabled: !!wholesalerId,
    });
};
